// extracted by mini-css-extract-plugin
export default {"SpinnerContainer":"Spinner_SpinnerContainer__Elf2E","Spinner":"Spinner_Spinner__X4zd5","spinner":"Spinner_spinner__J01-O"};